import axios from 'axios'
import { API } from '@/main'
import { axiosInstance } from '../../src/helpers/axiosInterceptor';

export default {
    async test () {
        return axiosInstance.put(`${API}/customer-types/3`, {description: {en: 'Public lighting', sr: 'Јавно осветљење'}})
    },
    // Auth
    async fetchSelf () {
        return axiosInstance.get(`${API}/me`)
    },
    async testToken (request) {
        return axiosInstance.post(`${API}/test`, request)
    },
    async login (request) {
        return axiosInstance.post(`${API}/login`, request)
    },
    async logout () {
        return axiosInstance.post(`${API}/logout`)
    },
    async resetPassword (email) {
        return axiosInstance.post(`${API}/users/password-reset`, { email: email })
    },
    async resetPasswordToken (token, password, password_confirmation) {
        return axiosInstance.post(`${API}/password-reset/${token}`, { password: password, password_confirmation: password_confirmation })
    },
    async changePassword (password) {
        return axiosInstance.post(`${API}/change-password`, password)
    },
    async verification (token) {
        return axiosInstance.get(`${API}/verify/${token}`)
    },


    // Contents
    async fetchContents () {
        return await axiosInstance.get(`${API}/contents`)
    },
    async saveContents (request) {
        return axiosInstance.post(`${API}/contents`, request)
    },
    async updateContents (id, request) {
        return axiosInstance.put(`${API}/contents/${id}`, request)
    },
    async deleteContents (id) {
        return axiosInstance.delete(`${API}/contents/${id}`)
    },
    async fetchSingleContent (id) {
        return await axiosInstance.get(`${API}/contents/${id}`)
    },


    // Content images
    async fetchContentImages (id) {
        return await axiosInstance.get(`${API}/contents/${id}/images`)
    },
    async saveContentImages (id, request) {
        return axiosInstance.post(`${API}/contents/${id}/images`, request)
    },
    async deleteContentImages (id) {
        return axiosInstance.delete(`${API}/content-images/${id}`)
    },

    
    // Constants
    async fetchConstants () {
        return axiosInstance.get(`${API}/constants`)
    },
    async saveConstant (request) {
        return axiosInstance.post(`${API}/constants`, request)
    },
    async updateConstant (id, request) {
        return axiosInstance.put(`${API}/constants/${id}`, request)
    },
    async deleteConstant (id) {
        return axiosInstance.delete(`${API}/constants/${id}`)
    },
     
    // Customer Types
    async fetchCustomerTypes () {
        return axiosInstance.get(`${API}/customer-types`)
    },
    async saveCustomerType (request) {
        return axiosInstance.post(`${API}/customer-types`, request)
    },
    async updateCustomerType (id, request) {
        return axiosInstance.put(`${API}/customer-types/${id}`, request)
    },
    async deleteCustomerType (id) {
        return axiosInstance.delete(`${API}/customer-types/${id}`)
    },
    async fetchSingleCustomerType (id) {
        return await axiosInstance.get(`${API}/customer-types/${id}`)
    },

    
    // Menu items
    async fetchMenu () {
        return axiosInstance.get(`${API}/menus`)
    },
    async fetchMenuItems (menu) {
        return axiosInstance.get(`${API}/menus/${menu}`)
    },
    async fetchMenuItems () {
        return axiosInstance.get(`${API}/menus`)
    },
    async fetchSingleMenuItem (id) {
        return axiosInstance.get(`${API}/menus/${id}`)
    },
    async saveMenuItems (request) {
        return axiosInstance.post(`${API}/menus`, request)
    },
    async updateMenuItems (id, request) {
        return axiosInstance.put(`${API}/menus/${id}`, request)
    },
    async deleteMenuItems (id) {
        return axiosInstance.delete(`${API}/menus/${id}`)
    },



    //Municipalities
    async fetchMunicipalities () {
        return await axiosInstance.get(`${API}/municipalities`);
    },
    async fetchSingleMunicipality (id) {
        return await axiosInstance.get(`${API}/municipalities/${id}`);
    },
    async saveMunicipality (request) {
        return axiosInstance.post(`${API}/municipalities`, request)
    },
    async deleteMunicipality (id) {
        return axiosInstance.delete(`${API}/municipalities/${id}`)
    },
    async updateMunicipality (id, request) {
        return axiosInstance.put(`${API}/municipalities/${id}`, request)
    },
    async getProviderMunicipality(provider, municipality) {
        return await axiosInstance.get(`${API}/providers/${provider}/municipalities/${municipality}`)
    },
    async postMunicipalities(provider, ids) {
        return axiosInstance.post(`${API}/providers/${provider}/municipalities`, ids)
    },

    
    
    // Providers
    async fetchProviders() {
        return await axiosInstance.get(`${API}/providers`)
    },
    async saveProvider(request) {
        return axiosInstance.post(`${API}/providers`, request)
    },
    async updateProvider (id, request) {
        return axiosInstance.put(`${API}/providers/${id}`, request)
    },
    async deleteProvider(id) {
        return axiosInstance.delete(`${API}/providers/${id}`)
    },
    async fetchSingleProvider (id) {
        return axiosInstance.get(`${API}/providers/${id}`)
    },
    async fetchDistributors () {
        return await axiosInstance.get(`${API}/distributors`)
    },
    async fetchSuppliers () {
        return await axiosInstance.get(`${API}/suppliers`)
    },
    async uploadProviderImg (provider, request, headers) {
        return axios.post(`${API}/providers/${provider}/logo`, request, headers)
    },


    // Rates
    async fetchRates () {
        return axiosInstance.get(`${API}/provider-rates`)
    },
    async fetchProviderRates (id) {
        return axiosInstance.get(`${API}/providers/${id}/rates`)
    },
    async fetchAllRates () {
        return axiosInstance.get(`${API}/all-rates`)
    },
    async confirmRates (request) {
        return axiosInstance.post(`${API}/confirm`, {rates_to_be_confirmed: request})
    },
    async confirmSingleRate (request) {
        return axiosInstance.get(`${API}/provider-rates/${request}/confirm`)
    },
    async publishRates () {
        return axiosInstance.get(`${API}/publish`)
    },
    async saveRate (request) {
        return axiosInstance.post(`${API}/provider-rates`, request)
    },
    async updateRate (id, request) {
        return axiosInstance.put(`${API}/provider-rates/${id}`, request)
    },
    async deleteRates (id) {
        return axiosInstance.delete(`${API}/provider-rates/${id}`)
    },
    async fetchSingleRate (id) {
        return axiosInstance.get(`${API}/provider-rates/${id}`)
    },


    // Roles
    async fetchRoles () {
        return await axiosInstance.get(`${API}/roles`);
    },
    async saveUserRoles (id, role) {
        return axiosInstance.post(`${API}/users/${id}/roles`, role)
    },


    // Translations - frontend
    async fetchTranslations (url) {
        return axiosInstance.get(`${API}/translations${url}`)
    },
    async updateTranslations (id, request) {
        return axiosInstance.put(`${API}/translations/${id}`, request)
    },
    async saveTranslation (request) {
        return axiosInstance.post(`${API}/translations`, request)
    },

    // Translations - cms

    async fetchRenderTranslations () {
        return axiosInstance.get(`${API}/translations-rendered?q=cms`)
    },



    // Types

    async fetchProviderTypes() {
        return await axiosInstance.get(`${API}/provider-types`)
    },


    // Users
    async fetchUsers () {
        return await axiosInstance.get(`${API}/users`);
    },
    async fetchSingleUser (id) {
        return await axiosInstance.get(`${API}/users/${id}`);
    },
    async saveUsers (request) {
        return axiosInstance.post(`${API}/users`, request);
    },
    async updateUser (id, request) {
        return axiosInstance.put(`${API}/users/${id}`, request)
    },
    async fetchSingleUser (id) {
        return await axiosInstance.get(`${API}/users/${id}`);
    },
    async deleteUsers (id) {
        return axiosInstance.delete(`${API}/users/${id}`)
    },
   
    
}



// WEBPACK FOOTER //
// ./src/api/api.js